export const aboutSection = "about";
export const demographicsSection = 'demographics';
export const touchpointSection = 'touchpoint';
export const loadingSection = 'loading';
export const allSections = [
  aboutSection,
  demographicsSection,
  touchpointSection,
  loadingSection,
];

export const touchpointDisabled = 'touchpoint.disabled';
export const touchpointUnsupported = 'touchpoint.unsupported';
export const ruleUnsupported = 'rules.unsupported-rule';
